module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp2_8019.263ce7ed.png";